

import { useContext } from "react";
import { FaBars } from "react-icons/fa";
import HambargarClick from "../HambargarClick";
import MobileProfile from "./MobileProfile";
import "./MobileHeader.css";

import { ThemeContext } from "../context/themeContext";
import { AvatarContext } from "../context/AvatarContext";
import { UserContext } from "../context/UserContext";

export default function MobileHeader({
  isOpen,
  onOpen,
  onClose,
  setShowMobProfile,
  showMobProfile
}) {

  const { avatar,avatarColor } = useContext(AvatarContext);
  const { user } = useContext(UserContext);
  const { activeTheme } = useContext(ThemeContext);

  return (
    <>
      {/* Mobile Header */}
      <header
        className={`mobile-header ${
          activeTheme === "dark" ? "dark-mode" : ""
        }`}
      >
       <FaBars
          className="mobile-header-icon"
          onClick={() => {
            setShowMobProfile(false)
            if (isOpen) {
              onClose();
            } else {
              onOpen();
            }
          }}
        />


        <div
          className="profile-avatar-h"
           style={{ background: avatar ? "transparent" : avatarColor }}
          onClick={() =>{ 
            onClose();
            setShowMobProfile((s) => !s)

          }}
        >
          {avatar ? (
            <img
              src={avatar}
              alt="Profile"
              className="profile-avatar-img"
            />
          ) : (
            user?.name?.[0] || "?"
          )}
        </div>
      </header>

      {/* Mobile Profile Overlay */}
      <MobileProfile
        isOpen={showMobProfile}
        onClose={() => setShowMobProfile(false)}
      />

      {/* Mobile Sidebar */}
      <HambargarClick
        toggle={isOpen}
        onClose={onClose}   // ✅ single source of truth
      />
    </>
  );
}

